export default __webpack_public_path__ + "static/media/rampver-logo.c42959e2.png";